import { z } from 'zod';
import { createPaginatedSchema, paginationQueryParamsSchema } from '../common/index.js';
import { mortgageSchema } from '../mortgage/index.js';
import { UserBookmarkStatusEnum } from './base.js';
export const userMortgageSchema = mortgageSchema.extend({
    status: z.enum(UserBookmarkStatusEnum),
    is_user_lender: z.boolean(),
    date: z.iso.datetime(),
});
export const paginatedUserMortgageSchema = createPaginatedSchema(userMortgageSchema);
export const userMortgageQueryParamsSchema = paginationQueryParamsSchema.extend({
    status: z.enum(UserBookmarkStatusEnum).optional(),
});
